import CookiesBanner from './cookies-banner';
import './cookies.scss';

const CookiesBannerConfig = {
  name: 'cookies-banner',
  class: CookiesBanner,
  querySelector: {
    header: '#cc-header',
    dismiss: '#cc-accept-button',
    nextFocusItem: '.cc-dismiss',
  },
};

export default CookiesBannerConfig;
